import React from 'react';
import { Tooltip } from 'react-tooltip';
import { Dialog, DialogContent, DialogDescription } from '@/components/ui/dialog';
import { DialogTitle } from '@radix-ui/react-dialog';
import { Button } from '@/components/ui/button';

export function PrintOptionsModal({ open, onOpenChange, onSelectCovers, onSelectApplicator, onSelectQuestions, onSelectAnswerSheet, onSelectFull }) {
  const fullWarningTooltipId = React.useId();

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent
        size="sm"
        onClick={e => e.stopPropagation()}
      >
        <DialogTitle>Como deseja imprimir?</DialogTitle>
        <DialogDescription>Escolha o que será impresso.</DialogDescription>
        {/* flex-col explicito -- DialogFooter default vira flex-row a partir do
            breakpoint sm, e os labels sao longos o bastante pra causar rolagem
            lateral lado a lado. */}
        <div className="flex flex-col gap-2">
          <Button
            variant="outline"
            fullWidth
            onClick={onSelectApplicator}
          >
            Caderno do aplicador
          </Button>
          <Button
            variant="outline"
            fullWidth
            onClick={onSelectCovers}
          >
            Capas da prova
          </Button>
          <Button
            variant="outline"
            fullWidth
            onClick={onSelectQuestions}
          >
            Questões da prova
          </Button>
          <Button
            variant="outline"
            fullWidth
            onClick={onSelectAnswerSheet}
          >
            Cartões de resposta
          </Button>
          <Button
            fullWidth
            onClick={onSelectFull}
            className="h-auto min-h-10 whitespace-normal text-center"
            data-tooltip-id={fullWarningTooltipId}
            data-tooltip-content="Um único arquivo será gerado com capa personalizada, questões e cartão de resposta para cada aluno. Atenção: esse processo pode demorar em provas com muitas questões ou muitos alunos."
            data-tooltip-place="bottom"
          >
            Capas + Questões + Cartões de resposta
          </Button>
        </div>

        <Tooltip
          id={fullWarningTooltipId}
          className="tooltip max-w-64 text-center"
        />
      </DialogContent>
    </Dialog>
  );
}
